<template>
  <div class="editor-pay-conditions">
    <div class="editor-pay-conditions__block">
      <divider orientation="left">
        Оплата работ
      </divider>
      <row :gutter="16">
        <i-col span="12">
          <double-switcher
            :contract="contract"
            value="with_vat"
            left="без НДС"
            right="с НДС"
          />
        </i-col>
      </row>
    </div>
    <div class="editor-pay-conditions__block">
      <divider orientation="left">
        Приемка работ
      </divider>
      <div v-if="!contract_id">
        <row
          class="editor-pay-conditions__condition-row"
          :gutter="16"
          v-for="condition in conditions"
          :key="condition.id"
        >
          <i-col span="8">
            <div class="editor-pay-conditions__condition">
              <span class="ms-help label">{{ condition.conditionLabel }}</span>
              <div class="editor-pay-conditions__condition-days">
                <input-number
                  :min="0"
                  v-model="contract[condition.conditionProp]"
                />
                <double-switcher
                  :contract="contract"
                  :value="condition.isCalendarProp"
                  left="раб."
                  right="кален."
                />
              </div>
            </div>
          </i-col>
          <i-col span="12">
            <span class="ms-help label">
              {{ condition.specialLabel }}
            </span>
            <div class="editor-pay-conditions__condition-days">
              <input-number
                :min="0"
                v-model="contract[condition.specialProp]"
              />
              <double-switcher
                :contract="contract"
                :value="condition.isSpecialCalendarProp"
                left="раб."
                right="кален."
              />
            </div>
          </i-col>
        </row>
      </div>
      <row :gutter="16" style="margin-top: 16px;">
        <i-col span="12">
          <span class="ms-help label">Условие закрытия договора</span>
          <i-select placeholder="Условие" v-model="contract.contract_type">
            <i-option
              v-for="item in contractTypes"
              :value="item.value"
              :key="item.value"
            >
              {{ item.name }}
            </i-option>
          </i-select>
        </i-col>
      </row>
    </div>
  </div>
</template>

<script>
import DoubleSwitcher from '../helpers/double-switcher'
import { contractTypes, conditions } from '@/config/contracts'

export default {
  props: ['contract', 'main-contract-id'],
  components: {
    DoubleSwitcher
  },
  data () {
    return {
      contract_id: this.$route.query.contract_id,
      contractTypes,
      conditions
    }
  },
  created () {
    if (this.mainContractId) this.contract_id = this.mainContractId
  }
}
</script>

<style lang="less">
.editor-pay-conditions {
  &__condition-row:not(:first-child) {
    margin-top: 16px;
  }
  &__condition-days {
    display: flex;
    align-items: center;

    .ivu-input-number {
      margin-right: 16px;
    }
  }

  .ivu-select {
    width: 220px;
  }
}
</style>
